import { connect } from "react-redux";
import Login from "../components/Login/Login";
import { login } from "../actions/auth";

const mapStateToProps = state => {
  return {
    message: state.auth.error.message,
    loading: state.auth.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleLogin: (studentId, groupId) => dispatch(login(studentId, groupId))
  };
};

const LoginModal = connect(mapStateToProps, mapDispatchToProps)(Login);

export default LoginModal;
